/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Audit_Details_Spoken_Declined_DescInputs */



/**
* | output |
* | --- |
* | "Spoken decline: {tool}" |
*
* @param {Audit_Details_Spoken_Declined_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_spoken_declined_desc = /** @type {((inputs: Audit_Details_Spoken_Declined_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Spoken_Declined_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mündliche Ablehnung: ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Spoken decline: ${i?.tool}`)
});